import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom/client'; 

import { ConfigProvider, Drawer, message, theme } from 'antd';

import MarketingOperationCreateContent from './MarketingOperationCreateContent';
import { DARK_BG_CONTAINER, DEBUG_MODE } from '../../../helpers/Globals';
import confirmModal from '../../DiConfirmModal';
import { apiGetOperation } from '../../../helpers/Api';

const createOperation = ({context, operationId, userId, onSave, preSelectedAudience}) => {

   if (DEBUG_MODE) {
      console.log("Modifico l'operazione con ID:",operationId);
   }
      
   // ------------- Crea un div temporaneo nel DOM per far comparire il drawer -------------
   const drawerContainer = document.createElement('div');
   document.body.appendChild(drawerContainer);
   // ------------- Crea un div temporaneo nel DOM per far comparire il drawer -------------

   // ------------- Componente Drawer -------------
   const DrawerComponent = () => {
      
      const [operationData, setOperationData] = useState(null);
      const [loading, setLoading] = useState(false);
      const [open, setOpen] = useState(false);

      const { darkMode, errorNotification, publicCode } = context;


      
      const handleClose = async () => {
         const result = await confirmModal(
            "Hai effettuato delle modifiche, chiudendo le perderai... Consigliamo di salvare il pubblico. Sicuro di voler chiudere?",
            context
         ); //attendo la risposta dal componente di conferma modale

         if (result) {
            setOpen(false); 
         } else {
            console.log("resto aperto");
         }

      };


      /////////////////////////////////////////////////////////////////////////////////////////// 
      //////////////// se c'è l'id prima di aprire il drawer recupero i dati dell'operazione //////
      /////////////////////////////////////////////////////////////////////////////////////////// 

      useEffect(() => {
         if (!publicCode) {
            errorNotification("Public Code Assente")
            return
         };

         const fetchOperation = async () => {
            try {
               if (!operationId) {
                  setOpen(true); // Se operationId è null/undefined, apri il modal per crearne uno nuovo
                  return;
               }

               setLoading(true);
               message.loading("Caricamento...");

               const res = await apiGetOperation(publicCode, operationId);
               if (res && res.success === true) {
                  
                  if (DEBUG_MODE) {
                     console.log("----------- Dati dell'operazione da modificare --------------")
                     console.log(res.operation)
                     console.log("----------- Dati dell'operazione da modificare --------------")
                  }

                  setOperationData(res.operation);
                  setOpen(true);
               } else {
                  console.warn("Nessun dato ricevuto per l'audience:", operationId);
               }
            } catch (error) {
               console.error("Errore nel recupero dell'audience:", error);
            } finally {
               message.destroy();
               setLoading(false);
            }
         };

         fetchOperation();
      }, [operationId]);

      /////////////////////////////////////////////////////////////////////////////////////////// 
      //////////////// se c'è l'id prima di aprire il drawer recupero i dati dell'operazione //////
      ///////////////////////////////////////////////////////////////////////////////////////////
      
      

      
      return (
            <ConfigProvider
               theme={
               {
                  algorithm: darkMode ? theme.darkAlgorithm : theme.compactAlgorithm,
                  token:{
                     colorPrimary: "#008833",
                     colorBgContainer: darkMode ? DARK_BG_CONTAINER : "#fff"
                  }
               }
               }
            >
               <Drawer
                  title={!operationId ? "Crea la tua operazione" : `Stai modificando: ${operationData?.title}`}
                  className='di-create-audience-drawer'
                  onClose={handleClose}
                  placement="bottom"
                  destroyOnClose
                  height="100%"
                  open={open}
               >
               <MarketingOperationCreateContent
                  preSelectedAudience={preSelectedAudience}
                  operationData={operationData}
                  contextValue={context} 
                  closeModal={setOpen}
                  onSave={onSave}
                  userId={userId}
               />
               </Drawer>
            </ConfigProvider>
      );
   };
   // ------------- Componente Drawer -------------

   // ------------- rendering effettivo del drawer -------------
   const root = ReactDOM.createRoot(drawerContainer);
   root.render(<DrawerComponent />);
   // ------------- rendering effettivo del drawer -------------

};

export default createOperation;
